// @ts-nocheck
import { useEffect, useState } from 'react';
import Select from 'react-select';
import { useTranslation } from 'react-i18next';
import { ntxAPI } from '@API/axiosNeatex';
import SkeletonLoader from '@components/Shared/SkeletonLoader/SkeletonLine';

const TypeD = ({ item, handleSelectChange }) => {
  const { t, i18n } = useTranslation();

  const [valueSetList, setValueSetList] = useState([]);

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    async function GetData() {
      try {
        const { data } = await ntxAPI.get(`FlexValueSet/GetFlexValueList?FlexValueSetId=${item.flexValueSetId}`);
        let DataList = data?.map(item => ({
          value: item.id,
          label: i18n.language === 'ar' ? item.name2 : item.name
        }));

        // ترتيب البيانات حسب label
        const sortByLabel = () => {
          return DataList?.sort((a, b) => {
            if (a.label < b.label) return -1;
            if (a.label > b.label) return 1;
            return 0;
          });
        };

        setValueSetList(sortByLabel);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
        setIsLoading(false);
      }
    }

    GetData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.flexValueSetId]);

  return (
    <>
      <div className='form-group mb-3'>
        <label className='form-label'>{i18n.language === 'ar' ? item.lable2 : item.lable}</label>
        <div className='row'>
          {isLoading ? (
            <SkeletonLoader />
          ) : (
            valueSetList?.length > 0 && (
              <Select
                isClearable
                classNamePrefix='react-select'
                isSearchable
                options={valueSetList}
                name={item.id}
                required={item.requiredFlag}
                onChange={handleSelectChange}
                placeholder={i18n.language === 'ar' ? 'إختر' : 'Choose'}
                //~~
                menuPlacement='auto'
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
              />
            )
          )}
        </div>
      </div>
    </>
  );
};

export default TypeD;
